/** Shared field styles for policy wizards — PaceHRM design-system tokens. */

export const pwLabel = (_darkMode, size = "sm") =>
  `block ${size === "xs" ? "text-xs" : "text-sm"} mb-1 text-[hsl(var(--ds-muted-fg))]`;

export const pwMicroLabel = () =>
  "block text-[11px] font-medium mb-1 text-[hsl(var(--ds-muted-fg))]";

export const pwInput = () =>
  "w-full rounded-md border border-[hsl(var(--ds-border))] bg-[hsl(var(--ds-surface))] px-2.5 py-2 text-sm text-[hsl(var(--ds-fg))] outline-none placeholder:text-[hsl(var(--ds-muted-fg))] focus:border-[hsl(var(--ds-primary))] focus:ring-2 focus:ring-[hsl(var(--ds-ring))]";

export const pwSectionTitle = () =>
  "mb-2 text-sm font-semibold text-[hsl(var(--ds-fg))]";

export const pwSectionSubtitle = () =>
  "mb-2 text-xs font-semibold uppercase tracking-wide text-[hsl(var(--ds-muted-fg))]";

export const pwPrimaryBtn =
  "inline-flex h-9 items-center justify-center rounded-md border border-[hsl(var(--ds-primary))] bg-[hsl(var(--ds-surface))] px-3.5 text-sm font-semibold text-[hsl(var(--ds-primary))] hover:bg-[hsl(var(--ds-primary)/0.08)] hover:border-[hsl(var(--ds-primary-hover))] hover:text-[hsl(var(--ds-primary-hover))] disabled:opacity-45";

export const pwOutlineBtn =
  "inline-flex h-9 items-center justify-center rounded-md border border-[hsl(var(--ds-border))] bg-[hsl(var(--ds-surface))] px-3.5 text-sm font-semibold text-[hsl(var(--ds-fg))] hover:bg-[hsl(var(--ds-muted))] disabled:opacity-45";
